/* Retour fluide vers la collection (snippets/mpn-collection-return.liquid). Correctif oct. 2026 :
   - la memoire du clic produit n'est jamais ecrasee par la sauvegarde de sortie ;
   - la sortie n'enregistre jamais une position "en haut" (Safari peut remettre la page en haut en la quittant) ;
   - une collection ouverte normalement (lien, menu) efface l'ancienne memoire de cette adresse ;
   - apres le retour, le produit clique reste a sa place pendant que les images au-dessus finissent de se charger. */
(function () {
  if (window.__mpnRet) return; window.__mpnRet = true;
  var de = document.documentElement;
  /* adresse actuelle, filtres et tri compris (les filtres AJAX la modifient sans recharger la page) */
  function key() {
    var q = location.search.replace(/([?&])preview_theme_id=[^&]*&?/, '$1').replace(/[?&]$/, '');
    return 'mpn-ret:' + location.pathname + q;
  }
  function read() { try { return JSON.parse(sessionStorage.getItem(key()) || 'null'); } catch (e) { return null; } }
  function write(v) { try { sessionStorage.setItem(key(), JSON.stringify(v)); } catch (e) {} }
  function drop() { try { sessionStorage.removeItem(key()); } catch (e) {} }
  function grid() { return document.getElementById('product-grid'); }
  function count(g) { return g ? g.querySelectorAll(':scope > .grid__item:not(.item__push)').length : 0; }
  function pathOf(h) { try { return new URL(h, location.href).pathname; } catch (e) { return ''; } }
  var done = true, lastY = Math.round(window.scrollY || 0), clickAt = 0;

  /* derniere position reellement vue (mise a jour seulement page visible et hors restauration) */
  window.addEventListener('scroll', function () {
    if (done && document.visibilityState === 'visible' && Date.now() - clickAt > 1500) lastY = Math.round(window.scrollY);
  }, { passive: true });

  /* 1. Memoriser au clic sur un produit de la grille */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#product-grid a[href*="/products/"]');
    if (!a || !done) return;
    var li = a.closest('.grid__item');
    clickAt = Date.now();
    lastY = Math.round(window.scrollY);
    write({ p: pathOf(a.href), t: li ? Math.round(li.getBoundingClientRect().top) : 0, y: lastY, n: count(grid()), at: clickAt, c: 1 });
  }, true);

  /* 1 bis. Sortie par un autre chemin (menu, panier...) : seulement s'il n'y a pas eu de clic produit juste avant,
     et jamais une position en haut de page */
  window.addEventListener('pagehide', function () {
    if (!done || !grid()) return;
    if (clickAt && Date.now() - clickAt < 30000) return;
    if (lastY < 40) return;
    write({ p: '', t: 0, y: lastY, n: count(grid()), at: Date.now() });
  });

  /* Retour instantane (page gardee en memoire par le navigateur, Safari notamment) : le navigateur remet tout seul la page */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { done = true; clickAt = 0; lastY = Math.round(window.scrollY); de.classList.remove('mpn-ret-wait'); }
  });

  /* 2. Au retour : restaurer sans saut */
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var isBack = nav && nav.type === 'back_forward';
  if (nav && nav.type === 'navigate') { drop(); return; } /* collection ouverte normalement : comportement normal */
  var s = read();
  if (!isBack || !s || Date.now() - s.at > 3600000) return;
  if (!s.p && s.y < 40) return;
  var sr = 'scrollRestoration' in history;
  if (sr) history.scrollRestoration = 'manual';
  de.classList.add('mpn-ret-wait');
  done = false;
  var card = null, user = false;
  function reveal() {
    if (done) return; done = true;
    de.classList.remove('mpn-ret-wait');
    lastY = Math.round(window.scrollY);
    if (sr) setTimeout(function () { history.scrollRestoration = 'auto'; }, 0);
    hold();
  }
  setTimeout(reveal, 4000);

  function findCard(g) {
    if (!s.p) return null;
    var links = g.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (pathOf(links[i].href) === s.p) return links[i].closest('.grid__item');
    }
    return null;
  }
  function align() {
    if (card && document.body.contains(card)) {
      var d = Math.round(card.getBoundingClientRect().top - s.t);
      if (Math.abs(d) > 1) window.scrollTo(0, Math.max(0, Math.round(window.scrollY + d)));
    } else if (Math.abs(window.scrollY - s.y) > 1) {
      window.scrollTo(0, s.y);
    }
  }
  /* Les images / encarts au-dessus peuvent encore grandir apres l'affichage (Safari ne compense pas) :
     on garde le produit clique au meme endroit pendant 2,5 s, sauf si le visiteur touche l'ecran ou defile lui-meme. */
  function hold() {
    if (!card) return;
    var stop = function () { user = true; };
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true, once: true }); });
    var end = Date.now() + 2500;
    (function tick() {
      if (user || Date.now() > end) return;
      align();
      requestAnimationFrame(tick);
    })();
  }
  function land() {
    var g = grid();
    card = g && findCard(g);
    align();
    requestAnimationFrame(function () { align(); reveal(); });
  }
  function step() {
    if (done) return;
    var g = grid();
    if (!g) { land(); return; }
    /* produits charges au scroll : on recharge la suite (page masquee) jusqu'au produit clique / au nombre deja vu */
    if (!findCard(g) && count(g) < s.n && g.getAttribute('data-mpn-next')) {
      var b = document.querySelector('[data-mpn-inf]');
      var once = function () { document.removeEventListener('mpn:products-appended', once); setTimeout(step, 30); };
      document.addEventListener('mpn:products-appended', once);
      window.scrollTo(0, (b ? b.getBoundingClientRect().top + window.scrollY : document.body.scrollHeight) - window.innerHeight);
      return;
    }
    land();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(step, 30); });
  else setTimeout(step, 30);
})();
